<template>
    <div>
        <v-select
            v-model="role"
            ref="roleSelect"
            label="id"
            :filterable="false"
            :resetOnOptionsChange="resetOnOptionsChange"
            :multiple="multiple"
            @search="onSearch"
            @input="onChange"
            :options="options"
            :value="selectedValues"
            :placeholder="`Search ${placeholder}`"
            :class="{'filter-select': forFilters, 'is-invalid': hasError, 'is-multiple': multiple, 'is-single': !multiple}">
            <template slot="no-options">
                Search for a Role by Name
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center">
                    {{ option.name }}
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                    {{ option.name }}
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
    export default {
        props: {
            selectedValues: {
                type: Object,
                default: null
            },

            forFilters: {
                type: Boolean,
                default: false,
            },

            // excludeId: {
            //     type: Number,
            // },

            placeholder: {
                type: String,
                default: 'Roles',
            },

            hasError: {
                type: Boolean,
                default: false,
            },

            resetOnOptionsChange: {
                type: Boolean,
                default: false,
            },

            multiple: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {
            return {
                options: [],
                role: null,
            }
        },

        watch: {
            //Watcher for errors
            hasError(newValue, oldValue){
                //Set it
                this.hasError = newValue;
            },

            selectedValues(newValue, oldValue){
                if(newValue != null && Object.keys(newValue).length > 0 && !this.role)
                {
                    this.options.push(newValue);
                    this.role = newValue;
                }
            }
        },

        methods: {
            //Search
            onSearch: function(searchTerm, searchLoading){
                //Done loading
                searchLoading(true);

                //Send it
                this.$http.get('/roles/search', {term: searchTerm})
                    .then(res => {
                        //Set the data
                        this.options = res.data;

                        //Done loading
                        searchLoading(false);
                    });
            },

            onChange: function (selected) {
                this.$emit('vuselected', this.role);
            },

            reset(){
                //Set to null
                this.role = null;
                this.options = [];
                this.$refs.roleSelect.clearSelection();
            },

            setValue(role){
                this.options.push(role);
                this.role = role;
            },
        },

        mounted() {
            //Push the selected value. Null will default to the placeholder
            if(this.selectedValues != null && Object.keys(this.selectedValues).length > 0)
            {
                this.options.push(this.selectedValues);
                this.role = this.selectedValues;
            }
        }
    }
</script>

<style scoped>
    .filter-select {
        background-color: #fff;
    }

    .filter-select.open >>> .selected-tag {
        margin-top: 3px;
    }

    .filter-select >>> .dropdown-toggle {
        border: 1px solid #c6c6c6;
        max-height: 31px;
        margin-top: -1px;
        padding: 1px 0 3px 0;
    }

    .is-single.filter-select >>> .selected-tag {
        margin: 3px 0 0 0;
        padding-left: 5px;
        white-space: nowrap;
        overflow: hidden;
        width: 200px;
    }

    .filter-select >>> .vs__actions button {
        margin-top: 3px;
    }

    .is-multiple.filter-select >>> .selected-tag {
        font-size: 11px;
        height: 23px;
        margin: 2px 1px 0;
    }
</style>